export default "__VITE_ASSET__DFdQ3teG__"